<template>
	<div class="Promotion" style="">
		<Tou></Tou>
		<div class="PromotionBanner" ref="bannerheight" style="background-size: 100% 100%;" :style="'background: url('+require('@/assets/pc/prom/datu.png')+') no-repeat center;' ">
			<!-- <img ref="bannerheight" src="../../../assets/pc/prom/datu.png" alt="" @load="imgload"
				@click="handleBannerClick()" style="cursor: pointer" :style="{height:bannerheight + 'px'}" /> -->
			<div  style="align-items: center;">
				<div class="tit-52 ys-0 montserBold t-center"  style="font-weight: 700;">LYNX U BATTERY EXPANSION PROGRAM</div>
				<div class="tit-19 ys-0 montserLight pt-20 t-center ptop-contant" style="width: 67.5%;margin: 0 auto;">In recent years, we have launched three generations of batteries for household use: Lynx U G1, G2, and G3. However, due to technological advancements, these three battery models are not compatible for capacity expansion. To compensate for the additional battery purchases made by customers, we are pleased to offer a special discount program for our installer partners.</div>
			</div>
		</div>
		<div class="bj-0 w100">
			<!-- style="width: 70%;margin: 0 auto;" -->
			<div class="w1500">
				<div class="pt-147 pb-99 t-center montserBold tit-40">
					{{ gudingziduan.Promotion.title }}
				</div>
				<!-- 步骤 1 -->
				<div class="flex prom-item">
					<div style="background: #fff;">
						<div class="prom-left1">
							<div class=" prom-lefticon tit-20 montserBold ys-0 t-center" style="word-break: break-all">
								{{ gudingziduan.Promotion.joinstep }}1
							</div>
						</div>
						<div class="mb-20">
							<div class="t-center arrow-up montserBold tit-28 iconfont icon-xiala" style="opacity: 0.1;">
							</div>
							<div class="t-center arrow-up montserBold tit-28 iconfont icon-xiala" style="opacity: 0.3;">
							</div>
							<div class="t-center arrow-up montserBold tit-28 iconfont icon-xiala" style="opacity: 0.5;">
							</div>
							<div class="t-center arrow-up montserBold tit-28 iconfont icon-xiala" style="opacity: 0.7;">
							</div>
							<div class="t-center arrow-up montserBold tit-28 iconfont icon-xiala" style=""></div>
						</div>
					</div>
					<div class=" ml-80 mt-32 prom-right">
						<div class="flex mb-25 p-title" style="align-items: center;">
							<img src="../../../assets/pc/prom/icon.png" style="width: .5rem;height:.4rem;" />
							<div class="montserBold tit-30 ml-23" style="color: #D61518;">
								{{ gudingziduan.Promotion.title1 }}
							</div>
						</div>
						<div class="flex j-between buzhouyiyoubian" style="position: relative;">
							<div class="youbianlogo" style="top: -.3rem;position: absolute;right: 0;">
								<img src="../../../assets/pc/prom/logo.png" style="width:4.2rem;height:.84rem;" />
							</div>
							<div class="pl-13" style="width:60%;">
								<span class="montserLight tit-22"
									style="color:#222222;font-weight: 300;">{{ gudingziduan.Promotion.joinneirong1 }}</span>
								<span @click="dakaiurl(1)" class="montserLight tit-22 cur_pointer"
									style="text-decoration: underline;color: #e91a1c;font-weight: 300;">{{ gudingziduan.Promotion.joinneirong12 }}</span>
								<span class="montserLight tit-22"
									style="color:#222222;font-weight: 300;">{{ gudingziduan.Promotion.joinneirong13 }}</span>
							</div>
						</div>
					</div>
					<!-- <div class="buzhouyiyoubian ml-80 flex j-between" style="width:92%;">
						<div class="mt-32" style="width:60%;">
							<div class="flex mb-25">
								<img src="../../../assets/pc/prom/icon.png" style="width: .5rem;height:.4rem;">
								<div class="montserBold tit-30 ml-23" style="color: #D61518;">
									{{gudingziduan.Promotion.title1}}</div>
							</div>
							<div class="pl-13" style="word-break: break-all">
								<span class='montserLight tit-22'
									style="color:#222222;font-weight: 300;">{{gudingziduan.Promotion.joinneirong1}}</span>
								<span class='montserLight tit-22 cur_pointer'
									style="text-decoration: underline;color: #e91a1c;font-weight: 300;">{{gudingziduan.Promotion.joinneirong12}}</span>
								<span class='montserLight tit-22'
									style="color:#222222;font-weight: 300;">{{gudingziduan.Promotion.joinneirong13}}</span>

							</div>
						</div>
						<div class="pt-78 " style="width:34%">
							<img src="../../../assets/pc/prom/logo.png" style="width:4.2rem;height:.84rem;">
						</div>
					</div> -->
				</div>
				<!-- 步骤 2-->
				<div class="flex prom-item prom-item2 " ref="promitem1" style="position: relative;padding-top:.88rem;">
					<div class="mt-20 prom-left" :style="{width: (buzhouwidth+30)+ 'px' }">
						<div class="shushu" :style="{ height: henxianheight + 'px' }"
							style="width: 1px;background:#ebebeb;position: absolute;z-index:0;top:0px;left:.6rem"></div>
						<div class="cirle_box" style="position: absolute;z-index: 2;background: #fff;top:.7rem">
							<div class="prom-left1"  ref="promistem3">
								<div class=" prom-lefticon tit-20 montserBold ys-0 t-center">
									{{ gudingziduan.Promotion.joinstep }}2
								</div>
							</div>
							<div class="mb-20">
								<div class="t-center arrow-up montserBold tit-28 iconfont icon-xiala"
									style="opacity: 0.1;"></div>
								<div class="t-center arrow-up montserBold tit-28 iconfont icon-xiala"
									style="opacity: 0.3;"></div>
								<div class="t-center arrow-up montserBold tit-28 iconfont icon-xiala"
									style="opacity: 0.5;"></div>
								<div class="t-center arrow-up montserBold tit-28 iconfont icon-xiala"
									style="opacity: 0.7;"></div>
								<div class="t-center arrow-up montserBold tit-28 iconfont icon-xiala" style=""></div>
							</div>
						</div>
						<!-- <div style="width: 1px;height:11rem;background: #e9e9e9;margin:0 auto;"></div> -->
					</div>
					<div class=" flex prom-right prom-right22" :style="{marginLeft:( buzhouwidth-20)+'px' }">
						<div class="mt-16  " style="">
							<div class="flex mb-22 p-title" style="align-items: center;">
								<img src="../../../assets/pc/prom/icon2.png" style="width: .42rem;height:.48rem;" />
								<div class="montserBold tit-30 ml-23" style="color: #D61518;word-break: break-all">
									{{ gudingziduan.Promotion.title2 }}
								</div>
							</div>
							<div class="pl-13">
								<span class="montserLight tit-22"
									style="color:#222222;">{{ gudingziduan.Promotion.joinneirong2 }}</span>
							</div>
							<div class="prom-form mt-75">
								<div class="flex j-between form4">
									<div class="prom-inputbox">
										<div class="prom-inputname tit-16 montserLight mb-10">
											{{ gudingziduan.Promotion.joinn2from.Name }}
										</div>
										<el-input @change="denglutishi" size="medium" class="prom-input" placeholder="" v-model="shu.name">
										</el-input>
									</div>
									<div class="prom-inputbox">
										<div class="prom-inputname tit-16 montserLight mb-10">
											{{ gudingziduan.Promotion.joinn2from.City }}
										</div>
										<el-input @change="denglutishi" size="medium" class="prom-input" placeholder="" v-model="shu.city">
										</el-input>
									</div>
									<div class="prom-inputbox">
										<div class="prom-inputname tit-16 montserLight mb-10">
											{{ gudingziduan.Promotion.joinn2from.Country }}
										</div>
										<el-input @change="denglutishi" size="medium" class="prom-input" placeholder="" v-model="shu.country">
										</el-input>
									</div>
									<div class="prom-inputbox">
										<div class="prom-inputname tit-16 montserLight mb-10">
											{{ gudingziduan.Promotion.joinn2from.Zip }}
										</div>
										<el-input @change="denglutishi" size="medium" class="prom-input" placeholder="" v-model="shu.zipCode">
										</el-input>
									</div>
								</div>
								<div class="mt-26">
									<div class="prom-inputname tit-16 montserLight mb-10">
										{{ gudingziduan.Promotion.joinn2from.CompanyName }}
									</div>
									<el-input @change="denglutishi" size="small" class="prom-input" placeholder="" v-model="shu.companyName">
									</el-input>
								</div>
								<div class="mt-26">
									<div class="prom-inputname tit-16 montserLight mb-10">
										{{ gudingziduan.Promotion.joinn2from.StreetHousenumber }}
									</div>
									<el-input @change="denglutishi" size="small" class="prom-input" placeholder="" v-model="shu.street">
									</el-input>
								</div>
								<div class="flex j-between mt-25">
									<div style="width: 48.8%;">
										<div class="prom-inputname tit-16 montserLight mb-10">
											{{ gudingziduan.Promotion.joinn2from.Email }}
										</div>
										<el-input @change="denglutishi" size="medium" class="prom-input" placeholder="" v-model="shu.mail">
										</el-input>
									</div>
									<div style="width: 48.8%;">
										<div class="prom-inputname tit-16 montserLight mb-10">
											{{ gudingziduan.Promotion.joinn2from.Phone }}
										</div>
										<el-input @change="denglutishi" size="medium" class="prom-input" placeholder="" v-model="shu.phone">
										</el-input>
									</div>
								</div>
								<div class="flex j-between mt-25">
									<div style="width: 48.8%;">
										<div class="prom-inputname tit-16 montserLight mb-10">
											{{ gudingziduan.Promotion.joinn2from.IBAN }}
										</div>
										<el-input @change="denglutishi" size="medium" class="prom-input" placeholder="" v-model="shu.iban">
										</el-input>
									</div>
									<div style="width: 48.8%;">
										<div class="prom-inputname tit-16 montserLight mb-10">
											{{ gudingziduan.Promotion.joinn2from.BIC }}
										</div>
										<el-input @change="denglutishi" size="medium" class="prom-input" placeholder="" v-model="shu.bic">
										</el-input>
									</div>
								</div>
								<div class="mt-26">
									<div class="prom-inputname tit-16 montserLight ">
										{{ gudingziduan.Promotion.joinn2from.purchaseddevices }}
									</div>
									<div class="prombox flex mb-10" v-for="(l, i) in shu.deviceNoList"
										style="align-items: center;">
										<el-input size="small" class="" placeholder="" v-model="shu.deviceNoList[i]"
											@change="shibie($event, i)">
										</el-input>
										<div v-if="i == 0" @click="tianjia(1)"
											class="mr-18 tit-26 t-center cur_pointer iconfont icontianjia"
											style="width: .26rem;"></div>
										<div v-else @click="remove(i, 1)"
											class="t-center tit-26 mr-18 cur_pointer iconfont  iconguanbi"
											style="width: .26rem;"></div>
										<!-- <img @click="tianjia(1)" src="../../../assets/pc/prom/iconjia.png" class="mr-18 cur_pointer" style="width: .26rem;height:.26rem;"/> -->
									</div>
								</div>
								<div class="mt-26">
									<div class="prom-inputname tit-16 montserLight ">
										{{ gudingziduan.Promotion.joinn2from.recogniseddevices }}
									</div>
									<div v-for="(l, i) in shu.deviceRecognisedNoList" class="prombox flex mb-10"
										style="align-items: center;">
										<el-input size="small" class="" placeholder="" @change="denglutishi"
											v-model="shu.deviceRecognisedNoList[i]">
										</el-input>
										<div v-if="i == 0" @click="tianjia(2)"
											class="mr-18 tit-26 t-center cur_pointer iconfont icontianjia"
											style="width: .26rem;"></div>
										<div v-else @click="remove(i, 2)"
											class="t-center tit-26 mr-18 cur_pointer iconfont iconguanbi"
											style="width: .26rem;"></div>
									</div>
								</div>
								<el-upload class="upload-demo tit-15 pt-20" style="" ref="upload" action="https://community.goodwe.com/api/upload/file" 
									:on-success="onSuccess" :on-change="onChange" :on-remove="handleRemove" :file-list="fileList1">
									<div class="flex a-center w100 flex-wrap box">
										<div class="prom-inputname mr-21 tit-16  montserLight">
											{{gudingziduan.Promotion.joinn2from.Purchaseorder}}:</div>
										<el-button slot="trigger" size="small" type="primary"
											class="PostFrom-btn1 tit-18 B-300 ys-33 B-400 mr-10 cur_pointer iconfont iconshangchuan"
											style="border: none;background: #F5F5F5;montserLight"></el-button>
										<div class="tit-14 B-300 montserLight" style="color:red;word-break: break-all;text-align: left;">Supported files: xls, xlsx, pdf,ppt, pptx,docx,doc,zip, rar,   (Max: 10 files, 5MB each)</div>
									</div>
								</el-upload>
								<!-- <div class="mt-26">
									<div class="prom-inputname tit-16 montserLight mb-10">
										{{ gudingziduan.Promotion.joinn2from.Purchaseorder }}
									</div>
									<el-upload :multiple="false" class="w100 shangchuangbox"
										style="" ref="upload" action="https://community.goodwe.com/api/upload/file"
										:on-success="onSuccess" :limit="10" >
										<div class="prombox2 flex mb-10 w100"
											style="align-items: center;justify-content:space-between;">
											<div class="pl-18">{{ wenjianname }}</div>
											<div slot="trigger"
												class="mr-18 tit-28 t-center cur_pointer iconfont iconshangchuan"
												style="width: .26rem;"></div>
										</div>
									</el-upload>
									<div  class="el-upload__tip tit-14 B-300 montserLight" style="color:red;">Supported files: xls, xlsx, pdf,ppt, pptx,docx,doc,zip, rar,   (Max: 10 files, 5MB each)</div>
								</div> -->
								<div class="mt-26" style="width: 31%;">
									<div class="prom-inputname tit-16 montserLight mb-10">
										{{ gudingziduan.Promotion.joinn2from.Amount }}
									</div>
									<el-input size="small" class="prom-input prom-input2" placeholder=""
										v-model="totalRebateAmount" @change="denglutishi">
									</el-input>
								</div>
								<div @click="Tijiao" class="querensong2  cur_pointer t-center tit-18 mt-54">
									{{ gudingziduan.Promotion.joinn2from.Submit }}
								</div>
								<div class="w100 zw" style="height: 136px;"></div>
							</div>
						</div>
					</div>
				</div>
				<!-- 步骤 3-->
				<div class="flex prom-item prom-item3">
					<div style="background: #fff;margin-top: -3px;">
						<div class="prom-left1">
							<div class=" prom-lefticon tit-20 montserBold ys-0 t-center">
								{{ gudingziduan.Promotion.joinstep }}3
							</div>
						</div>
					</div>
					<div class="ml-80 flex pb-174 prom-right">
						<div class="" style="">
							<div class="flex mb-25 p-title">
								<img src="../../../assets/pc/prom/icon3.png" style="width: .42rem;height:.48rem;" />
								<div class="montserBold tit-30 ml-23" style="color: #D61518;">
									{{ gudingziduan.Promotion.title3 }}
								</div>
							</div>
							<div class="pl-13">
								<span class="montserLight tit-22" style="color:#222222;">{{
                  gudingziduan.Promotion.joinneirong3
                }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bj-0 prom_dbll" style="width: 68%;margin:1.08rem auto 1.38rem auto;border-radius: 22px;">
			<div class="Mechanismbox pt-77 pl-88 pr-79 pb-47">
				<div v-for="(item, index) in zixun" :key="index" class="faq-item">
					<div class="faq-question flex items-center justify-between cur_pointer"
						@click="toggleItem(index)">
						<div class="question-text tit-24 montserRegular" :class="
                item.xian === true ? 'xuanhongse montserRegular' : 'weixuan2'
              ">
							{{ item.biaoti }}
						</div>
						<div class="toggle-icon tit-30 cur_pointer" :class="
                item.xian === true ? 'xuanhongse xuanhongse2' : 'weixuan'
              ">
							{{ item.xian === true ? "×" : "+" }}
						</div>
					</div>

					<transition name="slide">
						<div class="faq-answer" v-show="item.xian === true">
							<div class="answer-content tit-17 montserLight pt-38 pb-28" v-if="index!=2">
								{{ item.neirong }}
							</div>
							<div class="answer-content tit-17 montserLight pt-38 pb-28" v-if="index==2">
								By upgrading to Lynx U G3, customers will enjoy several significant advantages:
								<div>
									<span  class="montserBold"  style="font-weight: bold;">· Enhanced Performance:</span>  
										The Lynx U G3 features advanced battery technology, providing higher energy density, longer cycle life, and improved efficiency.
								</div>
								<div>
									<span class="montserBold" style="font-weight: bold;">
										· Advanced Safety Features: 
									</span>
									 With state-of-the-art safety mechanisms, including over-voltage protection, over-current protection, and thermal management systems, the Lynx U G3 ensures the safety and reliability of the energy storage system. 
								</div>
								 <span   class="montserBold" style="font-weight: bold;">
									· Smart Connectivity: 
								 </span>
									It supports smart monitoring and remote control, allowing customers to manage their energy consumption more effectively and conveniently.
							</div>
						</div>
					</transition>
				</div>
			</div>
		</div>
		<div class="prxieyi w100" ref="bannerheight" style="background-size: 100% 100%;" :style="'background: url('+require('@/assets/pc/prom/bg.jpg')+') no-repeat center;' ">
			<div class="prxieyi-contant flex  a-center w1500">
				<img  class="prxieyi-tu cur_pointer" src="../../../assets/pc/prom/bg-logo.png" style="width: 1.44rem;height:2.03rem;" />
				<div class="prxieyi-you pl-100">
					<div class="prxieyi-youtitile montserBold tit-40 cur_pointer">Lynx U Battery Expansion Program Terms&Conditions</div>
					<div @click="dakaiurl(2)" class="querensong3 cur_pointer t-center tit-18 mt-54" style="">{{gudingziduan.Promotion.LearnMore}}</div>
				</div>
			</div>
		</div>
		<div>
			<StayTact></StayTact>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from "../../../zuzuzu/touss.vue";
	import StayTact from "../../../components/StayTact.vue";
	import Foot from "../../../zuzuzu/foot.vue";
	import {
		guangao
	} from "@/api/index.js";
	import {
		Device,
		Repeated
	} from "@/api/questionnaire.js";
	import {allUser } from '@/api/user.js';
	export default {
		data() {
			return {
				fileList1: [],
				lunbolist: [],
				bannerheight: "",
				gudingziduan: {},
				shu: {
					deviceNoList: [""],
					deviceRecognisedNoList: [""]
				},
				henxianheight: 0,
				zixun: [{
						biaoti: "Membership Requirement",
						neirong: "Installers are required to join our GoodWe Plus+ installer membership program. This program is designed to provide our partners with exclusive benefits, including technical support, training resources, and priority access to new product information. ",
						xian:false
					},
					{
						biaoti: "Rebate Mechanism",
						xian:false,
						neirong: "Once joined, installers can upload necessary purchase orders and installation records. Meanwhile, the installer will receive an email as proof of participation. After verification, we will provide a rebate of €140 for each Lynx U G3 battery installed. In addition, each newly purchased Lynx U G3 battery under this promotion will receive a one-year warranty extension. Both the rebate and the warranty extension will be processed within six weeks.This rebate not only helps to offset the cost of the additional batteries but also rewards our partners for their continued support and excellent service.",
					},
					{
						biaoti: "Benefits of Lynx U G3",
						xian:false,
						neirong: "By upgrading to Lynx U G3, customers will enjoy several significant advantages: · Enhanced Performance: The Lynx U G3 features advanced battery technology, providing higher energy density, longer cycle life, and improved efficiency. · Advanced Safety Features: With state-of-the-art safety mechanisms, including over-voltage protection, over-current protection, and thermal management systems, the Lynx U G3 ensures the safety and reliability of the energy storage system. · Smart Connectivity: It supports smart monitoring and remote control, allowing customers to manage their energy consumption more effectively and conveniently.",
					},
				],
				activeIndex: null,
				wenjianname: "",
				buzhouwidth:0,
				wenjianlei:[],
				userisPlus:false
			};
		},
		components: {
			Tou,
			Foot,
			StayTact,
			allUser
		},
		watch: {
			"$store.state.cunyuanyan": {
				handler(newValue, oldValue) {
					this.gudingziduan = this.$store.state.cunyuanyan;
				},
				deep: true, // 如果 cunyuanyan 是对象，需要设置 deep 为 true
			},
		},
		computed: {
			// 计算非空设备编号数量
			nonEmptyDeviceCount() {
				if (!this.shu.deviceNoList) return 0;
				return this.shu.deviceNoList.filter((item) => item.trim() !== "").length;
			},
			// 计算总金额（非空数量×140）
			totalRebateAmount() {
				return this.nonEmptyDeviceCount * 140;
			},
		},
		created() {
			guangao().then((s) => {
				this.lunbolist = s.data;
			});
			allUser().then(shu => {
				if(shu.code=='200') {
					this.userisPlus = shu.data.isPlus
				}
			})
			this.$store.commit("Gaiyuyan", this.$store.state.yuyan);
			this.gudingziduan = this.$store.state.cunyuanyan;
			// console.log(this.gudingziduan.Promotion)
		},
		mounted() {
			new this.$wow.WOW({
				live: false,
			}).init();
			if (!this.$qu("kouling")) {
				location.reload();
			}
			this.henxian();
			this.buzhoukuan()
			window.addEventListener("resize", this.imgload, false);
			window.addEventListener("resize", this.henxian); // 添加窗口调整大小的事件监听
			window.addEventListener("resize", this.buzhoukuan); // 添加窗口调整大小的事件监听
		},
		beforeDestroy() {
			window.removeEventListener("resize", this.imgload, false);
			window.removeEventListener("resize", this.henxian); // 清理事件监听
			window.removeEventListener("resize", this.buzhoukuan); // 清理事件监听
		},
		methods: {
			handleBannerClick(url) {
				if (url) {
					// 处理完整URL或相对路径
					const externalUrl = url.startsWith("https://community.goodwe.com") ?
						url :
						`https://community.goodwe.com${url}`;
					window.open(externalUrl, "_blank");
				}
			},
			onChange(file, fileList){
				var that = this;
				if(that.$qu('kouling').length==0) {
					that.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								that.$dakai('/login_in')
						  }
					  }
					});
					that.shu.attachment=""
					that.fileList1=[]
				}
			},
			onSuccess(e, file, fileList) {
				if (e.code == 200) {
					// attachment
					var that = this;
					// that.shu.attachment = e.data;
					// that.wenjianname = file.name;
					if(!that.wenjianlei){
						that.wenjianlei=[]
					}
					that.wenjianlei.push({
					  data: e.data,
					  uid: file.uid // el-upload 会为每个文件生成一个唯一的 uid
					})
				}
			},
			handleRemove(file, fileList) {
				const indexToRemove = that.wenjianlei.findIndex(item => item.uid === file.uid);
				if (indexToRemove !== -1) {
				  that.wenjianlei.splice(indexToRemove, 1);
				}
			},
			toggleItem(index) {
				// 如果点击的是已展开的项目，则关闭；否则展开新项目
				// this.activeIndex = this.activeIndex === index ? null : index;
				this.zixun[index].xian=!this.zixun[index].xian
			},
			imgload() {
				this.$nextTick(() => {
					if (this.$refs.bannerheight && this.$refs.bannerheight.width > 1100) {
						this.bannerheight = this.$refs.bannerheight.height;
					}else this.bannerheight = 260
				});
			},
			dakaiurl(e){
				if(e==1){
					window.open('https://community.goodwe.com/plus')
				}else if(e==2){
					// dakaiurl
					this.$router.push({ name: 'Lynx-U-Battery-Exchange-Promotion-Terms-Conditions'})
				}
			},
			henxian() {
				this.$nextTick(() => {
					this.henxianheight = this.$refs.promitem1.offsetHeight;
				});
			},
			buzhoukuan() {
				this.$nextTick(() => {
					this.buzhouwidth = this.$refs.promistem3.clientWidth;
					console.log(this.$refs.promistem3.clientWidth)
					console.log(888)
				});
			},
			denglutishi(){
				var that=this
				console.log(that.$qu('kouling'))
				if(that.$qu('kouling').length==0) {
					that.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								that.$dakai('/login_in')
						  }
					  }
					});
				}else{
					if(!this.userisPlus){
						this.$message({
						  showClose: true,
						  iconClass:'el-icon-warning',
						  customClass:'my-error-message',
						  message: 'GoodWe Plus+ members only.',
						  type: 'error',
						  offset:'350',
						  duration:0
						});
					}
				}
				if(!that.userisPlus || that.$qu('kouling').length==0){
					that.shu.deviceNoList = [" "];
					that.shu.deviceRecognisedNoList = [" "];
					that.shu.name = ''
					that.shu.city = ''
					that.shu.country = ''
					that.shu.zipCode = ''
					that.shu.companyName = ''
					that.shu.street = ''
					that.shu.mail = ''
					that.shu.phone = ''
					that.shu.iban = ''
					that.shu.bic = ''
					that.wenjianname = "";
					that.shu.attachment=""
					that.wenjianlei=[]
				}
			},
			Tijiao() {
				var that = this;
				that.wenjianlei = that.wenjianlei.map(file => file.data);
				that.shu.attachment=''
				for (let i in that.wenjianlei) {
					that.shu.attachment+=that.wenjianlei[i]+',';
				}
				that.shu.attachment=that.shu.attachment.substring(0,that.shu.attachment.length - 1)
				if(this.$qu('kouling').length==0) {
					this.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								this.$dakai('/login_in')
						  }
					  }
					});
				}else{
					Device(that.shu).then((s) => {
						if (s.code != 200) {
							this.$message({
								showClose: true,
								iconClass: "el-icon-warning",
								customClass: "my-error-message",
								message: s.message,
								type: "error",
								offset: "350",
								duration: 0,
							});
						} else {
							that.$cun('prfromshu',that.shu)
							that.shu.deviceNoList = [" "];
							that.shu.deviceRecognisedNoList = [" "];
							that.shu.name = ''
							that.shu.city = ''
							that.shu.country = ''
							that.shu.zipCode = ''
							that.shu.companyName = ''
							that.shu.street = ''
							that.shu.mail = ''
							that.shu.phone = ''
							that.shu.iban = ''
							that.shu.bic = ''
							that.wenjianname = "";
							that.$message({
								showClose: true,
								message: s.result,
								type: "success",
								offset: "350",
								duration: 2000,
							});
						}
					});
				}
			},
			shibie(e, index) {
				var that = this;
				if(that.$qu('kouling').length==0) {
					that.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								that.$dakai('/login_in')
						  }
					  }
					});
					that.shu.deviceNoList = [" "];
				}else{
					if (e) {
						 const otherValues = that.shu.deviceNoList.filter(
							(val, i) => val.trim() !== '' && i !== index
						  );
					  if (otherValues.some(val => val.trim().toLowerCase() === e.trim().toLowerCase())) {
						  that.$message({
							type: 'error',
							message: 'serial no already exists！',
							duration: 2000
						  });
						  
						  // 重置当前输入框的值
						  that.$set(that.shu.deviceNoList, index, "");
						  return false;
						}
						Repeated({
							serialNo: e
						}).then((s) => {
							if (s.code != 200) {
								that.$message({
									showClose: true,
									iconClass: "el-icon-warning",
									customClass: "my-error-message",
									message: "Please avoid duplicate entries.",
									type: "error",
									offset: "350",
									duration: 0,
								});
								// that.shu.deviceNoList[i]=''
								that.$set(that.shu.deviceNoList, index, "");
							}
						});
					}
					
				}
			},
			tianjia(e) {
				var that = this;
				if (e == 1) {
					if (!that.shu.deviceNoList) {
						that.shu.deviceNoList = [];
					}
					that.shu.deviceNoList.push("");
					console.log(1);
				} else if (e == 2) {
					if (!that.shu.deviceRecognisedNoList) {
						that.shu.deviceRecognisedNoList = [];
					}
					that.shu.deviceRecognisedNoList.push("");
					console.log(22);
				}
			},
			remove(index, e) {
				if (e == 1) {
					this.shu.deviceNoList.splice(index, 1);
				} else if (e == 2) {
					this.shu.deviceRecognisedNoList.splice(index, 1);
				}
			},
		},
	};
</script>

<style lang="scss">
	.PromotionBanner {
		background-size: 100% 100% !important;
		padding:1.48rem 0 1.6rem 0;
		img {
			height: 100%;
			width: 100%;
			object-fit: fill;
		}
	}

	.prom-item {
		flex-shrink: 0;
		align-items: flex-start;
		// justify-content: space-between;

		.prom-left1 {
			background-color: #f2f2f2;
			border-radius: 50%;
			padding: 0.1rem;

			.prom-lefticon {
				width: 1.03rem;
				height: 1.03rem;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 50%;
				// background:#F2F2F2;
				background: linear-gradient(-39deg, #e70a16 0%, #ff785c 100%);
				// border: 10.84px solid #f2f2f2;
				box-sizing: border-box;
			}
		}

		.arrow-up {
			height: 0.14rem;
			color: #eb8f90;
		}
	}
	.prxieyi{
		.prxieyi-contant{
			// width:85.652%;
			margin: 0 auto;
			padding:.72rem 0  .84rem 0;
			.prxieyi-tu{
				transition: all .36s;
			}
			.prxieyi-tu:hover{
				transform: scale(1.05);
			}
		}
	}
	.prom-form {
		.prom-inputbox {
			width: 23%;
		}

		.prom-inputname {
			color: #929292;
		}

		.shangchuangbox {
			.el-upload {
				width: 100%;
			}
		}

		.prom-input {
			.el-input__inner {
				background-color: #f2f2f2;
				border-radius: 0.1rem;
				border: none;
				height: 0.5rem;
				min-height: 38px;
			}
		}

		.prombox {
			background-color: #f2f2f2;
			border-radius: 0.1rem;
			height: 0.5rem;
			min-height: 38px;
			overflow: hidden;

			.el-input__inner {
				border-radius: 0.1rem;
				height: 0.5rem;
				min-height: 38px;
				border: none;
				background: inherit;
			}
		}
		.prombox2{
		}
		.prom-input2 {
			.el-input__inner {
				background-color: rgba(234, 39, 34, 0.1);
			}
		}
		.el-upload-list {
			display: flex;
			flex-wrap: wrap;
			margin-top: .43rem;
		
			// width: 100%;
			.el-upload-list__item {
				line-height: normal;
				// padding: 0;
				padding: .14rem .17rem;
				margin-top: 0;
				color: #9A9A9A;
				font-weight: 300;
			}
			.el-upload-list__item-status-label{
				top:20%;
			}
			.el-upload-list__item:not(:last-child) {
				margin-right: .17rem;
			}
		
			li {
				border: 1px dashed #dfdfdf;
				border-radius: 23px;
				width: auto;
			}
		}
		.PostFrom-btn1 {
			padding: .1rem .5rem;
			color: #333;
			background: #f5f5f5;
			border-radius: 23px;
			display: inline-block
		}
	}
	.Promotion{
			.querensong2 {
				min-width: 100px;
				width: 1.5rem;
				height: 0.5rem;
				min-height: 38px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 25px;
				background: linear-gradient(-47deg, #e70a16 0%, #ff785c 100%);
				color: #fff;
				border: 0;
			}
			.querensong3{
				min-width: 100px;
				width: 2.6rem;
				height: 0.5rem;
				min-height: 38px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 25px;
				background: linear-gradient(-47deg, #e70a16 0%, #ff785c 100%);
				color: #fff;
				border: 0;
			}
		
	}

	.Mechanismbox {
		.faq-item {
			// margin-bottom: 16px;
			padding-bottom: 0.26rem;
		}

		.faq-item:not(:first-child) {
			padding-top: 0.38rem;
		}

		.faq-item:not(:last-child) {
			border-bottom: 1px solid #eee;
		}

		.faq-question {
			font-size: 18px;
			font-weight: 500;
			// padding: 12px 0;
		}

		.faq-question:hover {
			color: #d61518;
		}

		.question-text {
			flex: 1;
		}

		.toggle-icon {
			width: 41px;
			height: 41px;
			text-align: center;
			color: #333;
			transition: transform 0.1s;
			border-radius: 50%;
			line-height: 41px;
			border: 1px solid #919191;
			box-sizing: border-box;
		}

		.faq-answer {
			line-height: 0.28ewm;
			color: #333333;
		}

		.slide-enter-active,
		.slide-leave-active {
			transition: all 0.1s ease;
			overflow: hidden;
		}

		.slide-enter-from,
		.slide-leave-to {
			max-height: 0;
			opacity: 0;
		}

		.slide-enter-to,
		.slide-leave-from {
			max-height: 1000px;
			opacity: 1;
		}

		.xuanhongse {
			color: #e91a1c;
			font-weight: 400;
		}

		.xuanhongse2 {
			border: 1px solid #e91a1c;
		}

		.weixuan {
			color: #919191;
		}

		.weixuan2 {
			color: #333;
		}
	}
		
	@media screen and (max-width: 1280px) {
		// .prom-right22{
		// 	margin-left: .4rem;
		// }
	}
	@media screen and (max-width: 1280px) {
		.prom-item .prom-left1 .prom-lefticon {
			min-width: 70px;
			min-height: 70px;
		}

		.prom-item .shushu {
			left: 38px !important;
		}
	}

	@media screen and (max-width: 768px) {
		.buzhouyiyoubian {
			flex-wrap: wrap;

			.youbianlogo {
				display:none ;
				// width: 100% !important;
				// position: initial !important;
				// display: block !important;
				// text-align: center;
				// margin: 0.3rem 0;
				// margin-bottom: 0.6rem !important;
			}
		}
		.PromotionBanner .ptop-contant{
			width:96% !important;
		}
		.prom-item {
			// flex-wrap: wrap;
			// justify-content: center;
			.prom-left1 .prom-lefticon {
				min-width:50px;
				min-height:50px;
				font-size:13px;
			}
			.prom-right22{width: auto !important;}
		}

		.prom-item .prom-right {
			margin: 0;
			width:100%;
			margin-top: 0.3rem;
			margin-left:0.2rem !important;
			// margin-left:0.2rem ;
		}

		.prom-item .prom-right .pl-13 {
			width:90% !important;
			padding: 0 !important;
			margin-left:0.2rem ;
			.montserLight {
				font-size: var(--font18);
			}
		}
		.prom-item .prom-right .p-title{
			margin-left:0.2rem ;
		}
		.prom-item2 {
			padding-top: 0rem !important;
		}

		.prom-item2 .shushu {
			display: none;
		}

		.prom-item2 .cirle_box {
			position: relative !important;
		}

		.prom-item2 .prom-right {
			margin-top: 1rem;
		}

		.prom-form {
			width: 115%;
			transform: translateX(-15%);
		}

		

		.prom-form .form4 {
			flex-wrap: wrap;
		}

		.prom-form .form4 .prom-inputbox {
			width: 48%;
			margin-top: 0.2rem;
		}

		.prom-form .querensong2 {
			margin: auto;
			margin-top: 0.5rem;
		}

		.prom-form .zw {
			height: 60px !important;
		}

		.prom_dbll {
			width: 96% !important;
		}

		.prom_dbll .Mechanismbox {
			padding: 0.4rem;
		}

		.Mechanismbox .toggle-icon {
			width: 30px;
			height: 30px;
			line-height: 30px;
		}

		.prom_dbll .question-text {
			font-size: var(--font20);
		}

		.prom_dbll .answer-content {
			font-size: var(--font12);
		}
		.prxieyi{
			.prxieyi-contant{
				.prxieyi-you{
					padding-left: .2rem !important;
					.prxieyi-youtitile{
						font-size: var(--font20) !important;
					}
					.querensong2{
						font-size: var(--font18) !important;
					}
				}
			}
		}
	}
</style>